import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';

// Pages
import Home from './pages/HomePage'; 
import Service from './pages/Service';
import Grabbing from './pages/Grabbing'; 
import Mine from './pages/Mine'; 
import Register from './pages/Register'; 
import Login from './pages/Login';      
import Record from './pages/Record';
import Deposit from './pages/Deposit'; 
import Withdraw from './pages/Withdraw';
import PaymentMethod from './pages/PaymentMethod'; 
import Settings from './pages/Settings'; 

// Components
import RechargeHistory from './components/RechargeHistory'; 
import WithdrawalHistory from './components/WithdrawalHistory'; 
import AdminPanel from './admin/AdminPanel';
import SplashScreen from './components/SplashScreen'; 
import BottomBar from './components/BottomBar';
import Loader from './components/Loader';

function AppContent() {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('user'));
  const [currentUser, setCurrentUser] = useState(JSON.parse(localStorage.getItem('user')));
  const [pageLoading, setPageLoading] = useState(false);

  const isAuthPage = location.pathname === '/login' || location.pathname === '/register';
  const isAdminPage = location.pathname.includes('admin-portal') || location.pathname.includes('admin');

  // ✅ Loader (auth pages par disable)
  useEffect(() => {
    if (isAuthPage) {
      setPageLoading(false);
      return;
    }

    setPageLoading(true);
    const timer = setTimeout(() => {
      setPageLoading(false);
    }, 400);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  useEffect(() => {
    const checkAuth = () => {
      const user = localStorage.getItem('user');
      setIsAuthenticated(!!user);
      setCurrentUser(user ? JSON.parse(user) : null);
    };
    window.addEventListener('storage', checkAuth);
    return () => window.removeEventListener('storage', checkAuth);
  }, []);

  return (
    <div className="App">
      {pageLoading && !isAuthPage && <Loader />} 

      <main className="main-content">
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          <Route path="/" element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
          <Route path="/home" element={isAuthenticated ? <Home /> : <Navigate to="/login" />} />
          <Route path="/service" element={isAuthenticated ? <Service /> : <Navigate to="/login" />} />
          <Route path="/grabbing" element={isAuthenticated ? <Grabbing /> : <Navigate to="/login" />} />
          <Route path="/mine" element={isAuthenticated ? <Mine /> : <Navigate to="/login" />} />
          <Route path="/record" element={isAuthenticated ? <Record currentUser={currentUser} /> : <Navigate to="/login" />} />
          
          <Route path="/deposit" element={isAuthenticated ? <Deposit /> : <Navigate to="/login" />} />
          <Route path="/withdraw" element={isAuthenticated ? <Withdraw /> : <Navigate to="/login" />} />
          
          <Route path="/recharge-history" element={isAuthenticated ? <RechargeHistory /> : <Navigate to="/login" />} />
          <Route path="/withdrawal-history" element={isAuthenticated ? <WithdrawalHistory /> : <Navigate to="/login" />} />
          
          <Route path="/payment-method" element={isAuthenticated ? <PaymentMethod /> : <Navigate to="/login" />} />
          <Route path="/settings" element={isAuthenticated ? <Settings /> : <Navigate to="/login" />} />
          
          <Route path="/admin-portal" element={<AdminPanel />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </main>
      
      {!isAuthPage && !isAdminPage && isAuthenticated && <BottomBar />}
    </div>
  );
}

function App() {
  const [showSplash, setShowSplash] = useState(false);

  useEffect(() => {
    const navType = performance.getEntriesByType("navigation")[0]?.type;
    const alreadyShown = sessionStorage.getItem('splashShown');

    // ✅ Sirf first open ya refresh par (aur ek hi dafa)
    if ((navType === "navigate" || navType === "reload") && !alreadyShown) {
      setShowSplash(true);
      sessionStorage.setItem('splashShown', 'true');

      const timer = setTimeout(() => {
        setShowSplash(false);
      }, 2500);

      return () => clearTimeout(timer);
    }
  }, []);

  if (showSplash) return <SplashScreen />;

  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;